import * as React from "react";
import { OverviewTableWrapper } from "../sections/overview-table-wrapper";
import "./tab.info.less";

export function TabOverview({ config, currentUri }: { config: any; currentUri: string }) {
    let queryParameters: any[] = [];
    if (config.useCurrentUri && currentUri) {
        queryParameters = [{ name: "term_iri", type: "uri", value: currentUri }];
    }
    return <OverviewTableWrapper query={config.query} queryParameters={queryParameters} />;
}
